import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => {
  const {
    palette: { secondary },
    breakpoints
  } = theme;

  return {
    pageHeader: {
      boxShadow: "none",
      [breakpoints.down(Breakpoints.SM_600)]: {
        height: "auto",
        display: "flex",
        flexDirection: "column",
        paddingBottom: 16,
        position: "static"
      }
    },
    internalPageHeaderContainer: {
      height: "100%",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "0 36px 0 24px",
      [breakpoints.down(Breakpoints.SM_600)]: {
        padding: "0 4px 0 16px",
        minHeight: 60,
        height: 60
      }
    },
    dropdownButton: {
      textTransform: "capitalize",
      padding: 0
    },
    allTracks: {
      fontSize: 20
    },
    allDatesContainer: {
      display: "flex",
      justifyContent: "end",
      minWidth: 300,
      [breakpoints.down(Breakpoints.MD_960)]: {
        minWidth: 220
      },
      [breakpoints.down(Breakpoints.SX_720)]: {
        minWidth: 150
      },
      [breakpoints.down(Breakpoints.SS_320)]: {
        minWidth: 140
      }
    },
    allDates: {
      color: secondary.dark
    },
    search: {
      width: "40%"
    },
    mobileViewSearch: {
      [breakpoints.down(Breakpoints.SM_600)]: {
        display: "flex",
        minWidth: "100%",
        padding: "0 18px 0 24px"
      }
    },
    facilityContainer: {
      display: "flex",
      height: 44,
      minWidth: 300,
      [breakpoints.down(Breakpoints.MD_960)]: {
        minWidth: 220
      }
    }
  };
});
